export { default } from './PostRow'
